module.exports = __webpack_public_path__ + "img/T940.40d48fcf.jpg";